export function MicMark() {
  return (
    <svg viewBox="0 0 32 32" aria-hidden="true" className="icon icon--mic">
      <path d="M11 8.5a5 5 0 0 1 10 0v7a5 5 0 0 1-10 0zM7.5 15.5a8.5 8.5 0 0 0 17 0M16 24v5M11.5 29h9" />
    </svg>
  );
}

export function StopMark() {
  return (
    <svg viewBox="0 0 32 32" aria-hidden="true" className="icon">
      <rect x="9" y="9" width="14" height="14" rx="2" />
    </svg>
  );
}

export function SwapMark() {
  return (
    <svg viewBox="0 0 32 32" aria-hidden="true" className="icon icon--swap">
      <path d="M7 11h17M20 7l4 4-4 4M25 21H8M12 17l-4 4 4 4" />
    </svg>
  );
}

